import { SeatMapResponseEnum } from "@b2bportal/air-booking-api";
import { Product } from "@b2bportal/purchase-api";
import { getObjectKeysAsObject } from "@checkout/helpers";
import { ParentState } from "@checkout/types";
import type { FlightContext } from "../../types";

export const guards = {
  hasSeatMapAvailability: (ctx: FlightContext, _event: unknown) =>
    ctx[ParentState.seatSelection].seatMapAvailable ===
    SeatMapResponseEnum.SeatMapAvailable,
  hasNoSeatMapAvailability: (ctx: FlightContext, _event: unknown) =>
    ctx[ParentState.seatSelection].seatMapAvailable ===
    SeatMapResponseEnum.SeatMapUnavailable,
  hasSeats: (ctx: FlightContext, _event: unknown) =>
    ctx[ParentState.seatSelection].selectedSeats.length > 0,
  notVisitedSeats: (ctx: FlightContext, _event: unknown) =>
    !ctx[ParentState.seatSelection].visited,
  notSkippedSeatSelection: (ctx: FlightContext, _event: unknown) =>
    !ctx[ParentState.seatSelection].skipSeatSelection,
  hasSeatProductInQuote: (ctx: FlightContext, _event: unknown) =>
    ctx[ParentState.cartQuote].quoteBreakdown?.products.some(
      (p) => p.product.type === Product.Seats
    ) ?? false,
};

export const GuardTypes = getObjectKeysAsObject(guards);
